

export default {
    includeIcon: function(url){ // 插入 Icon
        let link  = document.getElementsByTagName("link")[0]
        if(link.rel = 'icon') link.href = url
    },
    setTitle: function(val){ // 设置标题
        document.getElementsByTagName("title")[0].text = val
    }
}